<template>
  <div>
    <b-row style="margin-top: 40px;">
      <b-col cols="12">
        <!-- 热门视频 -->
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <h4>热门推荐</h4>
          <!-- <p class="needHover">换一换</p> -->
        </div>
        <ul class="news-list">
          <li style="display: flex;justify-content: start;" class="needHover" v-for="(item,index) in list"
            @click="$router.push({name:'normalDetail',params:{id:item.id}})">
            <img :src="item.logo" alt="" style="margin-right: 10px;width: 100px;height: 100px;" />
            <div style="display: flex;justify-content: space-between;flex-direction: column;">
              <p>{{ item.title }}</p>
              <div style="display: flex;justify-content: space-between;">
                <p style="font-size: 16px; ">{{item.create_time}}</p>
                <!-- <p style="font-size: 16px; " @click.stop="goZhuan">专题11<b-icon icon="bookmark-fill"
                    style="color: #FFBA01;"></b-icon></p> -->
              </div>
            </div>
          </li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    props: ['list'],
    data() {
      return {

      }
    },
    methods: {
      goZhuan() {
        console.log(666);
      }
    }
  }
</script>

<style>
  .needHover:hover {
    color: red;
    cursor: pointer;
  }

  .news-list {
    list-style-type: none;
    padding-left: 0;
  }

  .news-list>li {
    font-size: 20px;
    margin: 16px 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotVideo/hotVideo.vue